import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let wWidth = $(window).width();

function updateContainerWidth() {
    const container = $('.panels-container');
    return container.width() - window.innerWidth;
}

function createPanelAnimation() {
    const container = $('.panels-container');
    const amountOfScroll = updateContainerWidth();

    const tween = gsap.to(container, {
        x: () => -amountOfScroll,
        duration: 3,
        ease: 'none',
    });

    ScrollTrigger.create({
        trigger: '.feed-box',
        pin: true,
        start: 'top 160px',
        scrub: 1,
        animation: tween,
        end: `+=${amountOfScroll}`,
        // markers: true,
    });
}

function refreshScrollTrigger() {
    ScrollTrigger.refresh();
}

$(window).on('resize', function () {
    if ($(window).width() !== wWidth) {
        wWidth = $(window).width();
        refreshScrollTrigger();
    }
});
$('#page').resize(function () {
    refreshScrollTrigger();
});

// Initial setup
createPanelAnimation();